import { get, req, post } from '@/plugins/axios'

// 创建OEM寻源单
export function createOEM (data: any): any {
  return post('/order/searchSourceOrder/operate/create', data)
}

// 编辑OEM寻源单
export function updateOEM (data: any): any {
  const { searchSourceOrderSkuList, ...rest } = data
  return post('/order/searchSourceOrder/operate/customerUpdate', {
    searchSourceOrder: rest,
    searchSourceOrderSkuList
  })
}

// OEM辅料
export function getIngt (): any {
  return get('/order/ingredientsRecommandPlan/ingredients')
}

export function ingtPlan (name: string, ingredientsId: string): any {
  return req(`/order/ingredientsRecommandPlan/ingredients/${name}`, {
    ingredientsId
  })
}

export function ingtPrice (data: any): any {
  return req('/order/ingredientsRecommandPlan/ingredients/price', data)
}
/**
 * 寻源单列表（前台）
 * @param {Object} data
 */
export function sourcingOEMList (data: any) {
  return post('/order/searchSourceOrder/show/list', data)
}

/**
 * 寻源单详情（前台+后台）
 * @param {Object} data
 */
export function sourcingOEMDetail (params: any) {
  return get('/order/searchSourceOrder/show/detail', { params })
}

/**
 * 寻源单报价详情（前台+后台）
 * @param {Object} data
 */
export function sourcingOEMFeeDetail (params: any) {
  return get('/order/searchSourceOrderSupplierPrice/show/detail', { params })
}

/**
 * 寻源单复购申请列表（前台）
 * @param {Object} data
 */
export function reorderOEMList (params: any) {
  return get('/order/searchSourceOrderRepurchaseApply/show/list', { params })
}

/**
 * 发布寻源单（前台）
 * @param {Object} params
 */
export function publishOEM (params: any) {
  return get('/order/searchSourceOrder/operate/publish', { params })
}

/**
 * 取消待发布寻源单（前台）
 * @param {Object} params
 */
export function cancleWaitPublish (params: any) {
  return get(
    '/order/searchSourceOrder/operate/cancleWaitPublishSearchSourceOrder',
    { params }
  )
}

/**
 * 申请退款（前台）
 * @param {Object} params
 */
export function refundOEM (params: any) {
  return get('/order/searchSourceOrder/operate/applyRefund', { params })
}

/**
 * 复购申请
 * @param {Object} params
 */
export function askRepurchaseApply (params: any) {
  return get('/order/searchSourceOrderRepurchaseApply/operate/create', { params })
}

/**
 * 客户同意（前台）
 * @param {Object} params
 */
export function repurchaseAgree (params: any) {
  return get('/order/searchSourceOrderRepurchaseApply/operate/agree', { params })
}

/**
 * 客户不同意（前台）
 * @param {Object} params
 */
export function repurchaseReject (params: any) {
  return get('/order/searchSourceOrderRepurchaseApply/operate/reject', { params })
}

/**
 * 操作日志 在购入
 * @param {Object} data
 */
export function getRepurchaseLog (params: any) {
  return get('/order/searchSourceOrderRepurchaseApplyLog/customer/list', { params })
}

/**
 * 操作日志
 * @param {Object} data
 */
export function getLog (params: any) {
  return get('/order/searchSourceOrderLog/customer/list', { params })
}

/**
 * 查询寻源单是否收费
 * @param {Object} data
 */
export function getOemPrice (params: any) {
  return get('/order/searchSourceOrder/operate/isCharged', { params })
}

/**
 * 查看店铺是否加购过OEM大货单
 * @param {Object} data
 */
export function showWareIsExistOemApi (params: any) {
  return get('/customer/showWareIsExistOem', { params })
}

/**
 * 修改店铺是否加购过OEM大货单
 * @param {Object} data
 */
export function updateWareIsExistOemApi (data: any) {
  return post('/customer/updateWareIsExistOem', data)
}
